<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Users</h1>
          <p class="mt-2 text-sm text-gray-700">A list of all the Users.</p>
        </div>

        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="openUserModal(null)" type="button" class="block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
            Add User
          </button>
        </div>

        <div class="mt-4 sm:mt-0 ml-2 sm:flex-none">
            <select
                id="filter"
                name="filter"
                v-model="selectedFilter"
                @change="handleFilterChange"
                class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
              <option disabled selected value="">Filters</option>
              <option value="">---</option>
              <option value="with_trashed">With Trashed</option>
              <option value="only_trashed">Only Trashed</option>
            </select>
        </div>

      </div>
      <SearchComponent @setSearchText="setSearchText"/>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">

          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
              <tr>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">ID</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Photo</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">First Name</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Last Name</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Email</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Account Name</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Created at</th>
                <th scope="col" class="px-3 py-1 text-right text-sm font-semibold text-gray-900">Options</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
              <tr v-for="item in items" :key="item.id">
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.id }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <img :src="item.profile_photo" alt="" class="h-8 w-8 rounded-full bg-gray-800" />
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.first_name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.last_name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.email }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.account_name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.created_at }}</td>

                <td class="py-1 pl-3 text-sm font-medium sm:pr-0">
                  <div class="flex items-center justify-end gap-x-0">
                    <a v-if="![1, 11].includes(item.id)" :href="'/impersonate/take/' + item.id"  class="network-button-color hover:text-gray-900">
                      <i class="fa fa-user-secret m-1 fa-lg" aria-hidden="true"></i>
                    </a>
                    <RouterLink :to="{ name: 'UserShow', params: { id: item.id } }" class="network-button-color hover:text-gray-900">
                      <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </RouterLink>
                    <button @click="openUserModal(item.id)" v-if="!isAuditor" type="button" class="network-button-color hover:text-gray-900">
                      <PencilSquareIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                    <button @click="destroy(item.id)" v-if="!isAuditor" type="button" class="network-button-color hover:text-gray-900">
                      <TrashIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "../TwPaginationComponent.vue";
import {EyeIcon, PencilSquareIcon, TrashIcon} from "@heroicons/vue/20/solid";
import SearchComponent from "../SearchComponent.vue";
import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";
import UserCreateEditFormComponent from "../User/UserCreateEditFormComponent.vue";

export default {
  name: "UserIndexComponent",
  props: {
    accountId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null,
      searchText: null,
      selectedFilter: '',
    }
  },
  components: {
    PaginationComponent,
    EyeIcon,
    PencilSquareIcon,
    TrashIcon,
    SearchComponent,
    UserCreateEditFormComponent,
  },
  watch: {
    searchText: {
      handler(newValue, oldValue) {
        this.getItems();
      },
      deep: true
    },
  },
  computed: {
    isAuditor() {
      return this.$store.state.userIsAuditor;
    },
  },
  methods: {
    setSearchText(value) {
      this.searchText = value;
    },
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/users/index${this.accountId ? '/' +this.accountId : ''}?page=${page}`, {params: {'search_text': this.searchText, 'selected_filter': this.selectedFilter}}).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    destroy(id) {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/users/destroy/${id}`).then((res) => {
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          this.getItems();
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        })
      }
    },
    openUserModal(userId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: UserCreateEditFormComponent,
            attrs: {
              userId: userId,
              accountId: this.accountId ?? null,
              onReloadIndex() {
                self.getItems();
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
    handleFilterChange() {
      console.log('Selected Filter:', this.selectedFilter);
      this.getItems();
    },
  },
  created() {
    this.getItems();
  },
}
</script>